/** Preview Version to generate a PDF File with watermark - only first 3 steps */
import jsPDF from 'jspdf';

const styles = {
  title: {
    fontSize: 22,
    font: 'helvetica',
    style: 'bold',
    color: [0, 0, 0],
  },
  subtitle: {
    fontSize: 16,
    font: 'helvetica',
    style: 'normal',
    color: [80, 80, 80],
  },
  body: {
    fontSize: 12,
    font: 'times',
    style: 'normal',
    color: [50, 50, 50],
  },
};

const marginLeft = 20;
const maxWidth = 165; // A4 = 210mm, minus 2x 20mm Rand, etwas weniger für besseren Umbruch
let currentY = 30;
const lineHeight = 6;

function writeStyledText(doc, text, style = 'body') {
  const fontSizes = {
    title: 18,
    subtitle: 14,
    body: 11,
  };

  const pageHeight = doc.internal.pageSize.getHeight(); // z. B. 297 für A4 hochkant

  // Schriftart & Stil setzen
  doc.setFont("helvetica", "normal");
  if (style === 'title') doc.setFont("helvetica", "bold");
  if (style === 'subtitle') doc.setFont("helvetica", "bold");

  doc.setFontSize(fontSizes[style] || fontSizes.body);

  // Bessere Textumbruch-Logik für deutsche Wörter
  let lines;
  try {
    lines = doc.splitTextToSize(text, maxWidth - 5); // Etwas weniger Breite für besseren Umbruch
  } catch (e) {
    // Fallback für problematische Texte
    lines = [text];
  }

  lines.forEach(line => {
    // Prüfen, ob ein Seitenumbruch nötig ist
    if (currentY + lineHeight > pageHeight - 20) {
      doc.addPage();
      currentY = 20; // oben neu anfangen (20 mm Rand)
      // Wasserzeichen auf jeder Seite hinzufügen
      addWatermark(doc);
      
      // Schriftart und Größe nach Seitenumbruch zurücksetzen
      doc.setFont("helvetica", "normal");
      if (style === 'title') doc.setFont("helvetica", "bold");
      if (style === 'subtitle') doc.setFont("helvetica", "bold");
      doc.setFontSize(fontSizes[style] || fontSizes.body);
    }

    doc.text(line, marginLeft, currentY);
    currentY += lineHeight;
  });

  // Absatzabstand
  currentY += 4;
}

function addWatermark(doc) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  
  // Wasserzeichen hinzufügen
  doc.setFontSize(72);
  doc.setTextColor(200, 200, 200); // Sehr helles Grau
  doc.setFont("helvetica", "bold");
  
  // Text in der Mitte der Seite rotieren und zentrieren
  doc.text('PREVIEW', pageWidth / 2, pageHeight / 2, {
    angle: -45,
    align: 'center'
  });
  
  // Farbe zurücksetzen
  doc.setTextColor(50, 50, 50);
}

function getBranchenBesonderheiten(besonderheiten) {
  switch (besonderheiten) {
    case "Gesundheitswesen":
      return "Das Unternehmen unterliegt besonderen Aufbewahrungspflichten nach § 630f BGB und weiteren Vorschriften wie der Strahlenschutzverordnung. Patientenakten müssen bis zu 10 Jahre, bei bestimmten Unterlagen (z. B. Röntgenbilder) bis zu 30 Jahre archiviert werden. Datenschutz und Vertraulichkeit haben höchste Priorität.";
    case "Steuerberater und Wirtschaftsprüfer":
      return "Als Berufsgeheimnisträger ist das Unternehmen zur besonderen Vertraulichkeit verpflichtet. Aufbewahrungspflichten nach § 147 AO gelten für bis zu 10 Jahre. Die Archivierung muss revisionssicher und GoBD-konform erfolgen.";
    case "Handel":
      return "Das Unternehmen muss Kassendaten, Belege und Geschäftsunterlagen 10 Jahre gemäß § 147 AO aufbewahren. Es gelten besondere Anforderungen an die Archivierung digitaler Kassendaten (z. B. nach der Kassensicherungsverordnung) und die Einhaltung der GoBD.";
    case "Baugewerbe / Architektur / Ingenieurbüros":
      return "Das Unternehmen muss Pläne, Gutachten und Projektdokumentationen mindestens 10 Jahre aufbewahren. Aufgrund möglicher Haftungsansprüche können längere Archivierungszeiträume sinnvoll sein. Digitale Bauunterlagen (z. B. CAD-Dateien) müssen revisionssicher archiviert werden.";
    case "Gastronomie / Hotellerie":
      return "Das Unternehmen ist verpflichtet, Bewirtungsbelege, Kassendaten und Abrechnungen mindestens 10 Jahre aufzubewahren. Besondere Anforderungen gelten für digitale Kassensysteme gemäß GoBD und Kassensicherungsverordnung.";
    case "IT-Dienstleister / Softwareunternehmen":
      return "Die Dokumentation von Entwicklungsprozessen, Verträgen und Supportleistungen muss langfristig archiviert werden. Datenschutz nach DSGVO spielt eine zentrale Rolle, insbesondere bei der Speicherung und Verarbeitung von Kundendaten.";
    case "Kreativbranche":
      return "Verträge, Nutzungsrechte und Projektdokumentationen müssen langfristig aufbewahrt werden. Zudem fallen oft große Datenmengen (z. B. Bilder, Videos) an, deren sichere Archivierung und Datenschutz relevant sind.";
    case "Produzierendes Gewerbe / Industrie":
      return "Das Unternehmen muss Qualitätsnachweise, technische Unterlagen und Prüfberichte gemäß Produkthaftungsgesetz über die üblichen Aufbewahrungsfristen hinaus archivieren. Dokumentationen müssen revisionssicher geführt werden.";
    case "Immobilienunternehmen / Hausverwaltungen":
      return "Mietunterlagen, Nebenkostenabrechnungen und Übergabeprotokolle müssen bis zu 10 Jahre aufbewahrt werden. Teilweise gelten längere Fristen bei relevanten Verträgen und Eigentümergemeinschaftsunterlagen.";
    case "Sonstiges":
      return "Es müssen Geschäftsunterlagen, Belege und andere relevante Dokumente gemäß den allgemeinen Aufbewahrungspflichten nach § 147 AO aufbewahrt werden. Die Archivierung muss sicherstellen, dass alle Daten revisionssicher und GoBD-konform gespeichert werden.";
    default:
      return "Keine Angaben.";
  }
}

function writeOrgUnits(doc, orgUnits) {
  console.log("Schreibe Organisationseinheiten:", orgUnits);
  orgUnits.forEach(unit => {
    const steps = Array.isArray(unit.processStep)
      ? unit.processStep.join(', ')
      : unit.processStep || 'Keine Prozess-Schritte angegeben';
    writeStyledText(doc, `- ${unit.unit}: ${steps}.`, "body");
  });
}

// 🧩 Automatisch positionierter Text - PREVIEW VERSION (nur erste 3 Schritte)
export async function generatePreviewPDF(values){
  const doc = new jsPDF();
  
  // Wasserzeichen auf der ersten Seite hinzufügen
  addWatermark(doc);
  
  writeStyledText(doc, `Verfahrensdokumentation zur Belegablage für ${values.companyName || 'Unternehmen'}`, "title");
  writeStyledText(doc, `Version: ${values.version ?? "0"}`, "body");
  writeStyledText(doc, `Stand: ${values.releaseDate || new Date().toLocaleDateString('de-DE')}`, "body");

  writeStyledText(doc, "1 Vorbemerkungen zur Verfahrensdokumentation", "subtitle");
  writeStyledText(doc, `[1] Sämtliche Ausführungen und Änderungen der Verfahrensdokumentation unterliegen der Genehmigungspflicht der Geschäftsleitung, namentlich ${values.releasedBy || ''}.`, "body");
  writeStyledText(doc, `[2] Die vorliegende Verfahrensdokumentation wurde von der Geschäftsleitung am ${values.releaseDate || new Date().toLocaleDateString('de-DE')} von ${values.releasedBy || ''} freigegeben, trägt die Versionsbezeichnung ${values.version || ''} und gilt bis zu einer Aktualisierung ab ${values.releaseDate || new Date().toLocaleDateString('de-DE')}.`, "body");
  
  writeStyledText(doc, "2 Zielsetzung und Überblick", "subtitle");
  writeStyledText(doc, "2.1 Zielsetzung und Anwendungsbereich", "subtitle");
  writeStyledText(doc, `[1] Die vorliegende Verfahrensdokumentation beschreibt die Verfahren und Maßnahmen, die für die Belegablage von handels- und/oder steuerrechtlichen Belegen im Unternehmen gelten.`, "body");
  writeStyledText(doc, `[2] Gegenstand der Ablage und Aufbewahrung sind alle Belege, die der Dokumentation von Geschäftsvorfällen dienen, die handels- und/oder steuerrechtlich buchführungs- bzw. aufzeichnungspflichtig im Sinne der GoB (Grundsätze ordnungsmäßiger Buchführung) sind.`, "body");
  writeStyledText(doc, `[3] Die dargestellten Verfahren und Maßnahmen sind von allen Personen zu beachten, die an den einzelnen Prozess-Schritten beteiligt sind und für diese unterwiesen und autorisiert wurden. Nicht unterwiesene oder nicht autorisierte Personen dürfen nicht in den Prozess eingreifen.`, "body");
  writeStyledText(doc, `[4] Die vorliegende Verfahrensdokumentation beschränkt sich auf die Aspekte einer ordnungsmäßigen Ablage von Belegen unter Aufrechterhaltung der Beweiskraft der Buchführung und sonstigen Aufzeichnungen unter Berücksichtigung der geltenden handels- und steuerrechtlichen Ordnungsmäßigkeitsanforderungen.`, "body");
  
  writeStyledText(doc, "2.2 Unternehmen und organisatorisches Umfeld", "subtitle");
  writeStyledText(doc, `[1] Firmenname: ${values.companyName || ''}`, "body");
  writeStyledText(doc, `Standort: ${values.location || ''}`, "body");
  writeStyledText(doc, `Rechtsform: ${values.legalForm || ''}`, "body");
  if (values.specialIndustryFeatures !== "Sonstiges") {
    writeStyledText(doc, `Branche: ${values.specialIndustryFeatures || ''}`, "body");
  }
  writeStyledText(doc, `Unternehmenszweck: ${values.purpose || ''}`, "body");
  writeStyledText(doc, `Gewinnermittlungsart: ${values.profitMethod || ''}`, "body");
  writeStyledText(doc, `[2] Branchenbesonderheiten: ${getBranchenBesonderheiten(values.specialIndustryFeatures)}`, "body");
  
  writeStyledText(doc, `[3] Übersicht der Organisationseinheiten mit den zugehörigen Prozess-Schritten:`, "body");
  writeOrgUnits(doc, values.organizationUnits || []);
  
  writeStyledText(doc, "2.3 Rechtliche Grundlagen", "subtitle");
  writeStyledText(doc, `[1] Die Aufbewahrungsfrist von Belegen beträgt 8 Jahre für Handelsbücher, Inventare, Lageberichte, Konzernlageberichte sowie die zu ihrem Verständnis erforderlichen Arbeitsanweisungen und sonstigen Organisationsunterlagen, Belege für Buchungen in den vom Kaufmann nach § 238 Abs. 1 HGB zu führenden Büchern (Buchungsbelege), vgl. § 257 Abs. 4 i.V.m. § 257 Abs. 1 Nr. 1, 4 HGB, § 147 Abs. 3 i.V.m. § 147 Abs. 1 Nr. 1, 4, § 5 AO.`, "body");
  writeStyledText(doc, `[2] Nach § 14b UStG sind ein Doppel aller ausgestellten Rechnungen sowie alle erhaltenen Rechnungen aufzubewahren. Dabei sind gem. § 14 Abs. 1 S. 2 ff. UStG die Echtheit der Herkunft, die Unversehrtheit ihres Inhalts und ihre Lesbarkeit über den gesamten Aufbewahrungszeitraum sicherzustellen und durch ein einzurichtendes innerbetriebliches Kontrollverfahren zu gewährleisten.`, "body");
  writeStyledText(doc, `[3] Die Aufbewahrungsfrist von Belegen beträgt 6 Jahre für empfangene Handels- oder Geschäftsbriefe und Wiedergaben der abgesandten Handels- oder Geschäftsbriefe und sonstige Unterlagen, vgl. § 257 Abs. 4 i. V. m. § 257 Abs. 1 Nr. 2,3 HGB, § 147 Abs. 3 i. V. m. § 147 Abs. 1 Nr. 2, 3, 5 AO. Handelsbriefe sind nur Schriftstücke, die ein Handelsgeschäft betreffen (§ 257 Abs. 2 HGB).`, "body");
  
  writeStyledText(doc, "2.4 Relevante Unterlagen mit Belegfunktion", "subtitle");
  writeStyledText(doc, `[1] Gegenstand der Belegablage sind alle originär in Papierform oder in digitaler Form eingehenden oder entstandenen bzw. vorliegenden Dokumente und Daten, die eine Belegfunktion im Sinne der handels- und/oder steuerrechtlichen Buchführungs- oder Aufzeichnungspflichten erfüllen und deshalb einer Aufbewahrungspflicht unterliegen.`, "body");
  writeStyledText(doc, `[2] Auf eine vollständige Aufzählung der relevanten Belege muss aufgrund deren Vielfalt ebenso verzichtet werden wie aufgrund der Tatsache, dass die Bezeichnung eines Dokuments alleine nicht ausschlaggebend dafür ist, ob es eine Belegfunktion erfüllt oder nicht. Unser Unternehmen verarbeitet unter anderem folgende Belegarten: ${values.belegartenInfo || ''}.`, "body");
  writeStyledText(doc, `[3] Wird in einem (Fremd- oder Eigen-)Beleg auf andere Unterlagen verwiesen, um den Buchungsvorfall verständlich zu machen, so gehören diese Unterlagen zwingend ebenfalls zu dem Beleg.`, "body");
  
  writeStyledText(doc, "3 Organisation und Sicherheit", "subtitle");
  writeStyledText(doc, "3.1 Eingesetzte Hard- und Software", "subtitle");
  writeStyledText(doc, `[1] Durch die Nutzung der nachfolgend bezeichneten Hard- und Software wird sichergestellt, dass bei ordnungsmäßiger und zeitlich ununterbrochener Anwendung die GoB eingehalten werden. Gleichzeitig wird sichergestellt, dass die digitalen und digitalisierten Unterlagen bei Lesbarmachung mit den empfangenen Handelsbriefen und den Buchungsbelegen bildlich und mit den anderen Unterlagen inhaltlich übereinstimmen, während der Dauer der Aufbewahrungsfrist verfügbar sind und jederzeit innerhalb angemessener Frist lesbar gemacht werden können (§ 257 Abs. 3 HGB, § 147 Abs. 2 AO) und für einen Datenzugriff im Falle einer steuerlichen Außenprüfung zur Verfügung gestellt werden können (§ 147 Abs. 6 AO).`, "body");
  writeStyledText(doc, `[2] Bei einer Änderung der digitalisierungs- und/oder archivierungsrelevanten Hardware und/oder Software wird neben der Dokumentation der Systemänderung sichergestellt, dass die Lesbarkeit der digitalisierten Dokumente gewährleistet bleibt.`, "body");
  writeStyledText(doc, `[3] Für die Ablage bzw. Archivierung der digitalen und digitalisierten Belege kommt folgende Hard- und Software mit der jeweiligen Konfiguration zum Einsatz:`, "body");
  writeStyledText(doc, `[3a] Eingesetzte Software:`, "body");
  
  const softwareList = (values.softwareList || [])
    .map(item => `• Seit ${item.startDate || 'kein Datum'}: ${item.details || 'keine Details angegeben'}`)
    .join('\n') || 'Keine Software angegeben.';

  writeStyledText(doc, `${softwareList}`, "body");
  writeStyledText(doc, `[3b] Eingesetzte Hardware:`, "body");

  const hardwareList = (values.hardwareList || [])
    .map(item => `• Seit ${item.startDate || 'kein Datum'}: ${item.details || 'keine Details angegeben'}`)
    .join('\n') || '• Keine Hardware eingetragen.';

  writeStyledText(doc, `${hardwareList}`, "body");
  writeStyledText(doc, `[4] Als Speichermedium für die digitalen und digitalisierten Belege kommen ${values.storageMedium || ''} zum Einsatz.`, "body");

  // Preview-Hinweis am Ende
  writeStyledText(doc, "PREVIEW-VERSION", "subtitle");
  writeStyledText(doc, `Diese Dokumentation wurde automatisch generiert am ${new Date().toLocaleDateString('de-DE')}`, "body");
  writeStyledText(doc, "GOBD-Konforme Verfahrensdokumentation zur Belegablage", "body");
  writeStyledText(doc, "Für die vollständige Dokumentation ist eine Lizenz erforderlich.", "body");

  doc.save(`PREVIEW_Verfahrensdokumentation_${values.companyName || 'Unternehmen'}.pdf`);
};
